import env from '../../services/env';
import WebSocket from 'isomorphic-ws';
import window from 'global/window';

class WebSocketService {
  constructor(userId, audienceHandler, milestoneHander) {
    if (!userId) {
      return;
    }
    this.userId = userId;
    this.socket = new WebSocket(env.WEBSOCKET_URI);
    this.socket.onopen = this.open;
    this.socket.onclose = this.close;
    this.socket.onmessage = this.incoming;
    this.socket.onerror = this.errorHandler;
    this.apiGWMessageTypeHandlers = {
      audience: audienceHandler,
      milestone: milestoneHander,
    };
    window.onbeforeunload = ()  => {
      this.socket.onclose = function () {}; // disable onclose handler first
      this.socket.close();
    };
  }

  constructMessageBody = (action, msg) => {
    return JSON.stringify({
      jbaction: action,
      jbmsg: msg
    });
  };

  sendMessage = (action, message) => {
    if (this.socket) {
      this.socket.send(this.constructMessageBody(action, message));
    }
  }

  incoming = (data) => {
    const msgFromApiGW = JSON.parse(data.data);
    //Locate handler in apiGWMessageTypeHandlers
    if (
      typeof this.apiGWMessageTypeHandlers[msgFromApiGW.msgtype] === 'function'
    ) {
      try {
        this.apiGWMessageTypeHandlers[msgFromApiGW.msgtype](
          msgFromApiGW.msgbody
        );
      } catch (err) {
        console.log('Error in handler for message', err);
      }
    } 
  };

  open = () => {
    this.socket.send(this.constructMessageBody("ADDUSER", this.userId));
  }

  close = closeEvent => {
    console.log('WebSocket : Socket closed from API GW ', closeEvent.code);
  };

  errorHandler = event => {
    console.log('WebSocket : Error occured ', event);
  }

  addMessageHandler = (msgType, handler) => {
    this.apiGWMessageTypeHandlers[msgType] = handler;
  }

}

export default WebSocketService;